module.exports = __webpack_public_path__ + "static/img/chu4.ee4ea3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chu4.jpg
// module id = Q1V3
// module chunks = 1